export default function styles(theme) {
  return {
    description: {
      color: theme.palette.text.tertiary,
    },
    textContainer: {
      display: "flex",
      gap: 10,
      flexDirection: "column",
    },
    achievementCard: {
      backgroundColor: theme.palette.primary.main,
      border: '1px solid rgba(121, 131, 150, 0.15)',
      padding: 25,
      width: "100%",
      borderRadius: 8,
    },
  };
}
